<script setup lang="ts">
import type { PropType } from "vue"
import type { Media } from "@/models"
import GalleryItem from "./GalleryItem.vue"

defineProps({
  items: {
    type: Array as PropType<Media[]>,
    default: () => [],
  },
})

const emit = defineEmits<{
  (e: "view", index: number): void
}>()

const onView = (index: number) => emit("view", index)
</script>

<template>
  <masonry :cols="{ default: 4, 1024: 3, 768: 2 }" :gutter="5">
    <div v-for="(item, index) in items" :key="index">
      <GalleryItem :item="item" @click="() => onView(index)" />
    </div>
  </masonry>
</template>
